import { render } from "./AttendancesList.vue?vue&type=template&id=b01a0a50&ts=true"
import script from "./AttendancesList.vue?vue&type=script&lang=ts"
export * from "./AttendancesList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__